export const ErrorMsgMap = {
  ASSET_HAS_EXISTS_WITH_TYPE: '禁止删除含资产数据的资产类',
  ASSET_TYPE_KEY_HAS_EXISTS: '资产标志重复',
} as { [key in string]: string };
